<div class="flex flex-col justify-center items-center">
  <p class="font-semibold text-2xl font-syne mb-10">
    Vi kan ikke beregne en pris
  </p>
  <p class="text-sm font-inter text-[#1F2937] mb-4">
    Købstædernes Forsikring kan desværre ikke beregne en pris
  </p>

  <p class="text-sm font-inter text-[#1F2937] mb-4">
    Kontakt os på support&#64;asgcare.dk
  </p>

  <p class="font-semibold text-sm font-inter text-[#1F2937]">
    Hvad er årsagen?:
  </p>
  <p
    *ngFor="let msg of ksfPriceResult.applicationMessages"
    class="text-sm my-1"
  >
    {{ msg.message }}
  </p>

  <p class="font-semibold text-2xl font-syne my-10">
    ... Eller prøv en af vores andre forsikringer
  </p>

  <div class="w-full">
    <!-- ############# -->
    <div class="flex items-center justify-center select-none mb-8">
      <div
        class="flex items-center justify-center bg-[#F1FCF9] rounded-l-full rounded-r-full"
      >
        <div
          [ngClass]="
            showYearlyPrice
              ? 'bg-[#072C29] text-[#F1FCF9] rounded-r-full'
              : 'bg-[#F1FCF9] text-[#072C29]'
          "
          (click)="showYearlyPrice = !showYearlyPrice"
          class="font-inter w-32 text-center text-xs p-1 rounded-l-full cursor-pointer"
        >
          Årlig
        </div>
        <div
          [ngClass]="
            !showYearlyPrice
              ? 'bg-[#072C29] text-[#F1FCF9] rounded-l-full'
              : 'bg-[#F1FCF9] text-[#072C29]'
          "
          (click)="showYearlyPrice = !showYearlyPrice"
          class="font-inter w-32 text-center text-xs p-1 rounded-r-full cursor-pointer"
        >
          Månedlig
        </div>
      </div>
    </div>

    <div class="grid lg:grid-cols-2 md:grid-cols-1 gap-10">
<!--      <ng-container-->
<!--        *ngIf="-->
<!--          false && !errorInSJFPrice && !errorIngetInsurancePrices;-->
<!--          else forsiaErrorTemplate-->
<!--        "-->
<!--      >-->
<!--        <app-sjf-price-card-->
<!--          [allHaveTogglePricetag]="allHaveTogglePricetag"-->
<!--          [showYearlyPrice]="showYearlyPrice"-->
<!--          [vehicleFromDmr]="vehicleFromDmr"-->
<!--          (pickSjfPriceEvent)="pickSjf(false)"-->
<!--          [forsiaExcessPrices]="forsiaExcessPrices"-->
<!--          [forsiaPrices]="forsiaPrices"-->
<!--          [selectedforsiaExcessIndex]="selectedforsiaExcessIndex"-->
<!--          (recalculateForsiaPricesEvent)="recalculateForsiaPrice()"-->
<!--          (setForsiaExcessTabEvent)="selectedforsiaExcessIndex = $event"-->
<!--          [forsiaTotalPrice]="forsiaTotalPrice"-->
<!--          [forsiaPriceLoading]="forsiaPriceLoading"-->
<!--        ></app-sjf-price-card>-->
<!--      </ng-container>-->

      <ng-template #forsiaErrorTemplate>
        <lib-error-price-card
          [company]="'Forsia'"
          [msg]="'Opdateres'"
        ></lib-error-price-card>
      </ng-template>

      <ng-container
        *ngIf="
          !errorInHelvetiaPrice && !errorIngetInsurancePrices;
          else helvetiaErrorTemplate
        "
      >
        <lib-helvetia-price-card
          [errorIngetInsurancePrices]="errorIngetInsurancePrices"
          [errorInHelvetiaPrice]="errorInHelvetiaPrice"
          [allHaveTogglePricetag]="allHaveTogglePricetag"
          [showYearlyPrice]="showYearlyPrice"
          [helvetiaMonthlyPrice]="helvetiaMonthlyPrice"
          [helvetiaYearlyPrice]="helvetiaYearlyPrice"
          [helvetiaVariants]="helvetiaVariants"
          [selectedHelvetiaVariant]="selectedHelvetiaVariant"
          [vehicleFromDmr]="vehicleFromDmr"
          (pickHelvetiaEvent)="pickHelvetia(false)"
          (setYearlyAndMonthlyPriceEvent)="setYearlyAndMonthlyPrice()"
          (setSelectedHelvetiaVariantEvent)="setSelectedHelvetiaVariant($event)"
        ></lib-helvetia-price-card>
      </ng-container>
      <ng-template #helvetiaErrorTemplate>
        <lib-error-price-card [company]="'Helvetia'"></lib-error-price-card>
      </ng-template>
    </div>
  </div>
</div>
